import { Box } from '@medly-components/core';
import styled from 'styled-components';
import { IconWrapper, StationWrapper } from '../../Station.styled';

export const SubZoneStationWrapper = styled(StationWrapper)`
    transform: translateY(-2.6rem);
`;

export const SubZoneIconWrapper = styled(IconWrapper)`
    width: 5.6rem;
    height: 9.25rem;
    display: flex;
    flex-direction: column;
    padding: 0.8rem;

    > :first-child {
        z-index: 1;
    }

    svg {
        width: 4rem;
        height: 4rem;
    }
`;

export const SubZoneExpandIcon = styled(Box)`
    width: 4rem;
    height: 4rem;
    background-color: ${({ theme }) => theme.colors.white};
    padding: 1rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    margin-top: -0.6rem;
`;
